// extracted by mini-css-extract-plugin
export var chip = "_fb-0";
export var filterDropdown = "_fb-5";
export var filterItem = "_fb-6";
export var icon = "_fb-1";
export var removeButton = "_fb-3";
export var removeIcon = "_fb-4";
export var separator = "_fb-2";